import { clientActionSubscribe, clientActionUnsubscribe } from './ClientAction'
import { EntityTypeEnum, FilterOperation, SubscribeType } from './generated'
import { NegotiationHistorySubscriptionIdentifier, SUBSCRIPTION_PAGE_SIZE, SubscriptionFilter } from 'api'
import { ActionsUnion } from 'utils'

function negotiationHistoryPageSubscribe(
  subscriptionIdentifier: NegotiationHistorySubscriptionIdentifier,
  filters: SubscriptionFilter[],
  pageNumber: number = 0
) {
  return clientActionSubscribe({
    entityTypeEnum: EntityTypeEnum.NEGOTIATION_HISTORY,
    preDefinedFilter: null,
    filters,
    postTransformFilters: [],
    subscribeType: SubscribeType.PAGE,
    subscriptionIdentifier,
    limitResults: false,
    pageSize: SUBSCRIPTION_PAGE_SIZE,
    pageNumber,
    summaryRequest: null
  })
}

function negotiationHistorySubscribe(orderIds: string[]) {
  return clientActionSubscribe({
    subscriptionIdentifier: NegotiationHistorySubscriptionIdentifier.HISTORY,
    entityTypeEnum: EntityTypeEnum.NEGOTIATION_HISTORY,
    preDefinedFilter: null,
    filters: [
      {
        fieldName: 'orderId',
        filterOperation: FilterOperation.CONTAINS,
        value: orderIds.join(','),
        calculatedValueType: null,
        orFilter: null,
        andFilter: null
      }
    ],
    postTransformFilters: [],
    subscribeType: SubscribeType.FILTERED,
    limitResults: true,
    pageNumber: null,
    pageSize: null,
    summaryRequest: null
  })
}

function negotiationHistoryUnsubscribeAll() {
  return clientActionUnsubscribe({
    subscriptionIdentifier: NegotiationHistorySubscriptionIdentifier.HISTORY,
    entityTypeEnum: EntityTypeEnum.NEGOTIATION_HISTORY
  })
}

export const AuditActions = {
  pageSubscribe: negotiationHistoryPageSubscribe,
  subscribe: negotiationHistorySubscribe,
  unsubscribeAll: negotiationHistoryUnsubscribeAll
}

export type AuditActions = ActionsUnion<typeof AuditActions>
